// extracted by mini-css-extract-plugin
export default {"card":"DataCard_card--M6k","header":"DataCard_header--aHk","content":"DataCard_content--YEC","footer":"DataCard_footer--rN4"};